import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

import React from "react";
import Slider from "react-slick";
import "../styles/Testimonial.css"; 

const Testimonial = () => {
  const images = [
    "Testimonials-1.webp",
    "Testimonials-3.webp",
    "Testimonials-4.webp",
    "Testimonials-5.webp",
    "Testimonials-6.webp",
    "Testimonials-7.webp",
    "Testimonials-8.webp",
    "Testimonials-9.webp",
    "Testimonials-10.webp",
    "Testimonials-11.webp",
    "Testimonials-12.webp",
    "Testimonials-13.webp",
    "Testimonials-14.webp",
  ];

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    autoplay: false,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024, 
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 768, 
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 360, 
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const message = "Need Cricket ID";
  const encodedMessage = encodeURIComponent(message);
  const ContactLink = `https://wa.me/918977772819?text=${encodedMessage}`;
  const whatsappLink = `https://wa.me/918977772819?text=${encodedMessage}`;

  return (
    <>
    <section className="success-stories-section" id="success-stories">
        {/* Title Section */}
        <div className="success-stories-header">
          <h2>
            <span className="highlight">Reddy Anna :</span> Success{" "}
            <span className="highlight">Stories</span> and Player{" "}
            <span className="highlight">Testimonials</span>
          </h2>
          <p>
          In the dynamic world of online gaming, Reddy Anna Book Official has established itself as a trustworthy platform, earning widespread acclaim and showcasing verified success stories from its users. By fostering a secure and transparent gaming environment, the platform has built a loyal community of players. Offering a variety of engaging games alongside features that promote responsible gaming, Reddy Book has crafted a formula that appeals to players seeking a credible and enjoyable gaming experience. The platform’s verified winnings and glowing reviews further cement its reputation as a dependable and rewarding destination in the highly competitive online gaming arena.
          </p>
        </div>

        {/* Carousel Section */}
        <div className="success-stories-gallery">
          <Slider {...settings}>
            {images.map((image, index) => (
              <div key={index} className="gallery-item">
                <img src={image} alt={`Success story ${index + 1}`} />
              </div>
            ))}
          </Slider>
        </div>
    </section>
     <section className="testimonialcontact">
     <a
     href={ContactLink}
     target="_blank"
     rel="noopener noreferrer"
     className="contact-btn testimonial-btn"
   >
     Contact Us @ 7777857777
   </a>
   <a
     href={whatsappLink}
     target="_blank"
     rel="noopener noreferrer"
     className="contact-btn testimonial-btn"
   >
     WhatsApp Us @ 7777857777
   </a>
     </section>
   </>
  );
};

export default Testimonial;
